import * as z from "zod";

// Raw schema for RPC type inference (no z.ZodType annotation)
export const ToneRangeSchemaRaw = z
  .object({
    min: z.number().int().min(1).max(5),
    max: z.number().int().min(1).max(5),
  })
  .refine((data) => data.min <= data.max, {
    message: "min must be less than or equal to max",
  });

export interface ToneRange {
  min: number;
  max: number;
}

export const ToneRangeSchema: z.ZodType<ToneRange> = ToneRangeSchemaRaw;

// Raw schema for RPC type inference (no z.ZodType annotation)
export const AiToneAndVoiceSettingsSchemaRaw = z.object({
  voiceInstructions: z.string().max(200).optional(),
  reasoning: z.string().max(300).optional(),
  formalityCasualness: ToneRangeSchemaRaw,
  seriousnessHumor: ToneRangeSchemaRaw,
  respectfulnessIrreverence: ToneRangeSchemaRaw,
  matterOfFactEnthusiasm: ToneRangeSchemaRaw,
});

export interface AiToneAndVoiceSettings {
  voiceInstructions?: string;
  reasoning?: string;
  formalityCasualness: ToneRange;
  seriousnessHumor: ToneRange;
  respectfulnessIrreverence: ToneRange;
  matterOfFactEnthusiasm: ToneRange;
}

export const AiToneAndVoiceSettingsSchema: z.ZodType<AiToneAndVoiceSettings> =
  AiToneAndVoiceSettingsSchemaRaw;

const aiToneAndVoiceSettingsUpdateSchema_ = z.object({
  voiceInstructions: z.string().max(200).optional(),
  reasoning: z.string().max(300).optional(),
  formalityCasualness: ToneRangeSchemaRaw.optional(),
  seriousnessHumor: ToneRangeSchemaRaw.optional(),
  respectfulnessIrreverence: ToneRangeSchemaRaw.optional(),
  matterOfFactEnthusiasm: ToneRangeSchemaRaw.optional(),
});
export const AiToneAndVoiceSettingsUpdateSchema: z.ZodType<AiToneAndVoiceSettingsUpdate> =
  aiToneAndVoiceSettingsUpdateSchema_;
export interface AiToneAndVoiceSettingsUpdate extends z.infer<
  typeof aiToneAndVoiceSettingsUpdateSchema_
> {}

export const aiToneAndVoiceSettingsDefault: AiToneAndVoiceSettings = {
  formalityCasualness: { min: 2, max: 4 },
  seriousnessHumor: { min: 2, max: 4 },
  respectfulnessIrreverence: { min: 2, max: 4 },
  matterOfFactEnthusiasm: { min: 2, max: 4 },
};
